export default __webpack_public_path__ + "static/media/back-button.68f6f9fb.svg";